import {
  validDate,
  convertEcdc,
  newDateFmt
} from '@/sui/data/flatten/tools'

import {
  patientAge,
  findSurveillance,
  unitType
} from '@/sui/data/flatten/common'

import moment from 'moment'

import microOrgs from '@/sui/data/microOrgs'

function findDataset (result, p) {
  const d = result.p.datasets
  if (d == null) {
    return null
  }

  const sv = d[result.ti].surv
  if (sv === p.sv && result.cache.ds != null) {
    return result.cache.ds
  }

  while (d[result.ti].surv < p.sv) {
    ++result.ti
    if (result.ti === d.length) {
      throw new Error(`Invalid index ${result.ti}`)
    }
  }

  const dataset = d[result.ti]
  result.cache.ds = dataset
  return dataset
}

function getDateFallback (dates) {
  for (let i in dates) {
    const d = dates[i]
    if (validDate(d) == null) {
      continue
    }
    return newDateFmt(d, fmt)
  }

  return null
}

const unk = 'UNK'
const fmt = 'YYYY-MM-DD'

function etbType (i) {
  if (i == null || i === 0) {
    return null
  }

  const types = [
    {
      spiadi: 1,
      ecdc: 'TERT'
    },
    {
      spiadi: 2,
      ecdc: 'SEC'
    },
    {
      spiadi: 3,
      ecdc: 'PRIM'
    },
    {
      spiadi: 4,
      ecdc: 'TERT'
    },
    {
      spiadi: 5,
      ecdc: 'SPEC'
    },
    {
      spiadi: 6,
      ecdc: 'SEC'
    },
    {
      spiadi: 7,
      ecdc: 'SPEC'
    },
    {
      spiadi: 8,
      ecdc: 'SPEC'
    },
    {
      spiadi: 9,
      ecdc: 'SPEC'
    },
    {
      spiadi: 10,
      ecdc: 'SPEC'
    },
    {
      spiadi: 11,
      ecdc: 'SPEC'
    },
    {
      spiadi: 12,
      ecdc: 'SPEC'
    },
    {
      spiadi: -1,
      ecdc: 'UNK'
    }
  ]
  return types.find(f => f.spiadi === i).ecdc
}

function speBedsDataset (d, ut, uf) {
  if (d == null || d === 0) {
    return null
  }
  const count = d.length
  let result = 0
  for (let i = 0; i !== count; ++i) {
    const di = d[i]
    if (di.uf === uf && di.ut === ut && di.den === 'bed') {
      result += di.val
    }
  }
  return result
}

function getSurvStart (ds, ut, un) {
  const count = ds.peri.length
  const uf = `${ut}.${un}`

  let result = null
  let dateUf = null

  for (let i = 0; i !== count; ++i) {
    const dp = ds.peri[i]
    if (dp.start == null) {
      continue
    }

    const d = newDateFmt(dp.start, fmt)
    if (dp.unit === uf) {
      if (dateUf == null || d < dateUf) {
        dateUf = d
      }
    } else if (result == null || d < result) {
      result = d
    }
  }
  return dateUf != null ? dateUf : result
}

function getSurvEnd (ds, ut, un) {
  const count = ds.peri.length
  const uf = `${ut}.${un}`

  let result = null
  let dateUf = null

  for (let i = 0; i !== count; ++i) {
    const dp = ds.peri[i]
    if (dp.end == null) {
      continue
    }

    const d = newDateFmt(dp.end, fmt)
    if (dp.unit === uf) {
      if (dateUf == null || d > dateUf) {
        dateUf = d
      }
    } else if (result == null || d > result) {
      result = d
    }
  }
  return dateUf != null ? dateUf : result
}

function getYesNoUnk (v) {
  let res = 'UNK'
  switch (v) {
    case 1:
      res = 'Y'
      break
    case 2:
      res = 'N'
      break
    case 9:
      res = 'UNK'
      break
  }
  return res
}

function getSex (v) {
  let res = 'UNK'
  switch (v) {
    case 1:
      res = 'M'
      break
    case 2:
      res = 'F'
      break
    case 3:
      res = 'O'
      break
    case 9:
      res = 'UNK'
      break
  }
  return res
}

function getInfectionOutcome (v) {
  let res = 'UNK'
  switch (v) {
    case 1:
      res = 'DUNKREL'
      break
    case 2:
      res = 'A'
      break
    case 9:
      res = 'UNK'
      break
  }
  return res
}

function getDead (v) {
  let res = 'UNK'
  switch (v) {
    case 1:
      res = 'D'
      break
    case 2:
      res = 'A'
      break
    case 9:
      res = 'UNK'
      break
  }
  return res
}

function getHasHAIICU (kts, pneus, bacts) {
  if (kts != null) {
    const count = kts.length
    for (let i = 0; i !== count; ++i) {
      const col = kts[i].isColIlcBlc
      // il faut bien tester tous les cas
      if (col === 2 || col === 3 || col === 4) {
        return 'Y'
      }
    }
  }

  if (pneus != null && pneus.length > 0) {
    return 'Y'
  }

  if (bacts != null) {
    const count = bacts.length
    if (count === 0) {
      return 'N'
    }

    for (let i = 0; i !== count; ++i) {
      const origin = bacts[i].origin
      if (origin === 1 || origin === 2) {
        return 'Y'
      }
    }
    // il y a des bactériémies communautaires, à vrai dire je sais pas s'il faut les noter 'O' ou 'N'
    // mais je n'ai pas le protocole pour potasser
    return 'O'
  }

  return 'N'
}

function getPatientOrigin (o) {
  let org = 'O'
  switch (o) {
    case 0:
      org = 'COM'
      break
    case 1:
      org = 'OICU'
      break
    case 2:
      org = 'HOSP'
      break
    case 3:
    case 5:
    case 6:
      org = 'LTC'
      break
    case 7:
      org = 'O'
      break
    case 9:
      org = 'UNK'
      break
  }
  return org
}

function getTypeOfAdmission (o) {
  let org = 'UNK'
  switch (o) {
    case 1:
      org = 'MED'
      break
    case 2:
      org = 'USUR'
      break
    case 3:
      org = 'SSUR'
      break
    case 9:
      org = 'UNK'
      break
  }
  return org
}

function getAntibiotic (o) {
  let atb = '_NOTEST'
  switch (o) {
    case 0:
      atb = 'OXA'
      break
    case 1:
      atb = 'C3G'
      break
    case 2:
      atb = 'FLU'
      break
    case 3:
      atb = 'GLY'
      break
    case 4:
      atb = 'CAR'
      break
    case 7:
      atb = 'ESBL'
      break
    case 10:
      atb = 'CAZ'
      break
    // Remove type and type 2 carbapenemas from antibiotics
    case 9:
    case 12:
    case 13:
    case 14:
      atb = null
      break
  }
  return atb
}

function getResistance (a, o) {
  let res = 'UNK'
  switch (a) {
    case 0:
      switch (o) {
        case 0:
          res = 'S'
          break
        case 1:
          res = 'IR'
          break
        case 2:
          res = 'UNK'
          break
      }
      break
    case 1:
      switch (o) {
        case 0:
          res = 'S'
          break
        case 1:
          res = 'I'
          break
        case 2:
          res = 'R'
          break
        case 3:
          res = 'UNK'
          break
      }
      break
    case 2:
      switch (o) {
        case 0:
          res = 'S'
          break
        case 1:
          res = 'R'
          break
        case 2:
          res = 'UNK'
          break
      }
      break
    case 3:
      switch (o) {
        case 0:
          res = 'S'
          break
        case 1:
          res = 'I'
          break
        case 2:
          res = 'R'
          break
        case 3:
          res = 'UNK'
          break
      }
      break
    case 4:
      switch (o) {
        case 0:
          res = 'S'
          break
        case 1:
          res = 'I'
          break
        case 2:
          res = 'R'
          break
        case 3:
          res = 'UNK'
          break
      }
      break
    case 5:
      switch (o) {
        case 0:
          res = 'N'
          break
        case 1:
          res = 'P'
          break
        case 2:
          res = 'C'
          break
        case 3:
          res = 'UNK'
          break
      }
      break
  }
  return res
}

function hasCVC (kt) {
  if (kt == null) {
    return 'N'
  }

  for (let i = 0; i < kt.length; ++i) {
    let tp = kt[i].type_v2
    if (tp == null) {
      tp = kt[i].type
    }

    if (isCVCFromKt(tp)) {
      return 'Y'
    }
  }
  return 'N'
}

function getSpeciality (s) {
  let spe = 'O'
  switch (s) {
    case 'AD REA BRU':
      spe = 'BURN'
      break
    case 'AD REA CAR':
      spe = 'CORO'
      break
    case 'AD REA MED':
      spe = 'MED'
      break
    case 'AD REA POL':
      spe = 'MIX'
      break
    case 'NEO REA':
      spe = 'NEON'
      break
    case 'AD REA NEU':
      spe = 'NEUR'
      break
    case 'PED REA':
      spe = 'PED'
      break
    case 'AD REA CHIR':
      spe = 'SURG'
      break
  }
  return spe
}

function BSIOrigin (s) {
  if (isCVC(s)) {
    return 'C-CVC'
  }

  if (s === 'C6' || s === 'C7') {
    return 'C'
  }

  if (s === 'C8' || s === 'C9' || s === 'C10' || s === 'C11' ||
      s === 'C12' || s === 'C13') {
    return 'C-PVC'
  }

  if (s === 'C5') {
    return 'C-ART'
  }

  if (s === 'A5' || s === 'A6') {
    return 'S-DIG'
  }

  if (s === 'A7' || s === 'A8' || s === 'A9' || s === 'A10' ||
      s === 'A11' || s === 'A12') {
    return 'S-OTH'
  }

  if (s === 'A3') {
    return 'S-PUL'
  }

  if (s === 'A2') {
    return 'S-SSI'
  }

  if (s === 'A1') {
    return 'S-SST'
  }

  if (s === 'A4') {
    return 'S-UTI'
  }

  if (s === 'A13') {
    return 'UO'
  }

  return 'UNK'
}

function isCVC (t) {
  return t === 'C1' || t === 'C2' || t === 'C3' || t === 'C4' || t === 'D1'
}

function isCVCFromKt (t) {
  return t === 'C1' || t === 'C2' || t === 'C3' || t === 'C4' || t === 'D1'
}

function infectionSite (s, t) {
  let site = 'OTH'
  switch (s) {
    case 2:
      if (isCVCFromKt(t)) {
        site = 'CRI1-CVC'
      } else {
        site = 'OTH'
      }
      break

    case 3:
      if (isCVCFromKt(t)) {
        site = 'CRI2-CVC'
      } else {
        site = 'OTH'
      }
      break

    case 4:
      site = 'CRI3-CVC'
      break
  }

  return site
}

function pnInfectionSite (s) {
  let site = 'PN-Nos'
  switch (s) {
    case 1:
      site = 'PN1'
      break
    case 2:
      site = 'PN2'
      break
    case 3:
      site = 'PN3'
      break
    case 4:
      site = 'PN4'
      break
    case 5:
      site = 'PN5'
      break
  }
  return site
}

function uFToID (uf) {
  const suf = uf.replace("'", ' ').replace('/', ' ').replace(',', ' ')
  const sp = suf.split(' ')
  let tmp = ''
  for (let i = 0; i < sp.length; ++i) {
    const si = sp[i]
    const sil = si.toLowerCase()
    if (sil === 'd' || sil === 'de' || si[0] === '(') {
      continue
    }

    if (si.match(/[0-9]/)) {
      tmp += si
    } else {
      tmp += si.substring(0, 3).toUpperCase()
    }
  }

  const nsp = tmp.split(':')
  return nsp[0].normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

function srvcId (p, s) {
  const res = `FR-${s.year}-${s.etb_finess}-${unitType(s.year, p.f.unitType)}-${uFToID(p.f.uf)}`
  return res.replace(/\s/g, '')
}

function patId (p, s) {
  const pid = p.id.split('-')
  const res = `${s}-${pid[2]}${pid[1]}`
  return res.replace(/\s/g, '')
}

function infId (s, t, d, i) {
  if (d == null) {
    d = 'UNK'
  }
  const nb = (i != null && i > -1) ? `#${i}` : ''
  const res = `${s}-${t}-${d.replace(/-/g, '')}${nb}`
  return res.replace(/\s/g, '')
}

function resId (s, mo, atb) {
  const res = `${s}-${mo}-${atb}`
  return res.replace(/\s/g, '')
}

function initializeHAIICU (p, s, ds) {
  const result = {
    RecordType: 'HAIICU'
  }
  result.RecordId = srvcId(p, s)
  result.RecordTypeVersion = 6
  result.Subject = 'HAIICU'
  result.Status = 'NEW/UPDATE'
  result.DataSource = 'FR-SPIADI'
  result.ReportingCountry = 'FR'
  result.DateUsedForStatistics = getSurvStart(ds, p.f.unitType, p.f.uf)
  result.Denom = ''
  result.HospitalComment = ''
  result.HospitalId = s.etb_finess
  result.HospitalSize = (s.etb_beds > 0) ? s.etb_beds : 'UNK'
  result.HospitalType = etbType(s.etb_type)
  result.NetworkId = ''
  result.NumAlcoholHandRubLiters = unk
  result.NumPatientDaysPrevYear = unk
  result.Pt = ''
  result.UnitId = p.f.uf
  result.UnitPercentIntub = ''
  result.UnitSize = speBedsDataset(ds.den, p.f.unitType, p.f.uf)
  result.UnitSpecialty = getSpeciality(unitType(s.year, p.f.unitType))
  result.UnitSurveillanceBSI = 'Y'
  result.UnitSurveillanceCRI = 'Y'
  result.UnitSurveillanceOTH = 'Y'
  result.UnitSurveillancePN = 'Y'
  result.UnitSurveillanceUTI = 'N'
  result.surv_id = p.sv
  return result
}

function initializeHAIICUPt (p, s, ds) {
  const result = {
    RecordType: 'HAIICU$Pt'
  }

  const id = srvcId(p, s)
  result.RecordId = patId(p, id)
  result.ParentId = id
  result.Age = patientAge(p.f, s.year)
  result.AntimicrobialAdmission = getYesNoUnk(p.f.antibio)
  result.AntimicrobialInUnit = 'UNK'
  result.BirthWeight = ''
  result.CVC = hasCVC(p.f.catheters)
  result.DateUnitAdmission = newDateFmt(p.f.entry, fmt)
  result.DateUnitDischarge = getDateFallback(
    [p.f.exit, p.f.death, getSurvEnd(ds, p.f.unitType, p.f.uf)]
  )
  result.Gender = getSex(p.f.sex)
  result.GestationalAge = ''
  result.HasHAI = getHasHAIICU(
    p.f.catheters, p.f.pneumopathies, p.f.bacteremias
  )
  result.ImpairedImmunity = getYesNoUnk(p.f.immuno)
  result.Intubation = getYesNoUnk(p.f.intubated)
  result.OtherScoreName = ''
  result.OtherScoreValue = ''
  result.OutcomeUnit = getDead(p.f.dead)
  result.PatientCounter = p.f.sheetNumber
  result.PatientOrigin = getPatientOrigin(p.f.origin)
  const msv = p.f.mainSeverity.value
  result.SapsII = (msv < 999) ? msv : null
  result.Trauma = getYesNoUnk(p.f.trauma)
  result.TypeOfAdmission = getTypeOfAdmission(p.f.diagnosis)
  result.UrinaryCatheter = getYesNoUnk(p.f.urinary)

  return result
}

function initializeHAIICUPtBact (b, pid, ri, infOut, kts, d) {
  const result = {
    RecordType: 'HAIICU$Pt$Inf'
  }

  result.RecordId = ri
  result.ParentId = pid

  result.BSIOrigin = BSIOrigin(b.entrance_v2)
  result.InvasiveDevice = unk
  result.DateOfOnset = d
  result.InfectionOutcome = infOut
  result.InfectionSite = 'BSI'

  if (b.entrance_v2 === 'A13' && isCVC(b.catheterType_v2)) {
    for (let i = 0; i !== kts.length; ++i) {
      const kt = kts[i]
      const id = getInvasiveDevice(
        b.episod, kt.insertion, kt.removal, kt.removed
      )

      if (id === 'Y') {
        result.BSIOrigin = 'C-CVC'
        result.InvasiveDevice = id
        break
      }
    }
  }

  result.InfectionSiteOther = ''
  result.Res = ''

  return result
}

function initializeHAIICUPtKt (b, pid, ri, infOut, invDev, d) {
  const result = {
    RecordType: 'HAIICU$Pt$Inf'
  }

  result.RecordId = ri
  result.ParentId = pid
  result.InfectionSite = infectionSite(b.isColIlcBlc, b.type_v2)
  result.BSIOrigin = bsiOriginKT(b.type_v2, b.isColIlcBlc, result.InfectionSite)
  result.DateOfOnset = d
  result.InfectionOutcome = infOut
  result.InfectionSiteOther = ''
  result.InvasiveDevice = invDev
  result.Res = ''

  return result
}

function initializeHAIICUPtPneu (b, pid, ri, infOut, invDev, d) {
  const result = {
    RecordType: 'HAIICU$Pt$Inf'
  }

  result.RecordId = ri
  result.ParentId = pid
  result.BSIOrigin = ''
  result.DateOfOnset = d
  result.InfectionOutcome = infOut
  result.InfectionSite = pnInfectionSite(b.diagnosis)
  result.InfectionSiteOther = ''
  result.InvasiveDevice = invDev
  result.Res = ''

  return result
}

function initializeHAIICUPtExp (ds, de, ty, pid, n) {
  const result = {
    RecordType: 'HAIICU$Pt$Exp'
  }

  result.RecordId = infId(pid, ty, ds, n)
  result.ParentId = pid

  const df = newDateFmt(de, fmt)
  result.DateExpEnd = df != null ? df : unk
  result.DateExpStart = ds
  result.ExpType = ty

  return result
}

function initializeHAIICUPtInfRes (r, m, pid, pdr) {
  const result = {
    RecordType: 'HAIICU$Pt$Inf$Res'
  }

  let resRec = 'UNK'
  result.ParentId = pid

  if (r != null) {
    resRec = r.code
    const atb = getAntibiotic(r.code)
    if (atb == null) {
      return null
    }
    result.Antibiotic = atb
    result.PDR = (pdr != null) ? pdr : '_NOTEST'
    result.SIR = getResistance(r.code, r.resistance)
  } else {
    result.Antibiotic = '_NOTEST'
    result.SIR = 'UNK'
    result.PDR = null
  }

  result.RecordId = resId(pid, m.code, resRec)
  result.ResultIsolate = microOrgs.completeList.v2.find(
    i => i.index === m.code
  ).ecdc

  return result
}

function containsICU (array, sv, year, ut, uf) {
  if (array == null) {
    return false
  }

  const spe = getSpeciality(unitType(year, ut))
  const f = array.findIndex(
    a => a.surv_id === sv && a.UnitSpecialty === spe && a.UnitId === uf
  )
  return f !== -1
}

function icuReducer (result, p) {
  const s = findSurveillance(result, p)
  const ds = findDataset(result, p)

  if (shouldBeIgnored(result, p, s, ds)) {
    return result
  }

  if (containsICU(result.r, p.sv, s.year, p.f.unitType, p.f.uf)) {
    return result
  }

  const unit = initializeHAIICU(p, s, ds)
  result.r.push(unit)
  return result
}

function icuPtReducer (result, p) {
  const s = findSurveillance(result, p)
  const ds = findDataset(result, p)

  if (shouldBeIgnored(result, p, s, ds)) {
    return result
  }

  const patient = initializeHAIICUPt(p, s, ds)
  result.r.push(patient)
  return result
}

function getInvasiveDevice (ep, st, end, rem) {
  const d = newDateFmt(ep, fmt)
  let ds = null
  if (st != null) {
    const is = newDateFmt(st, fmt)
    // date episode - date de pose
    ds = moment(d).diff(moment(is), 'days')
  }

  let de = null
  if (end != null) {
    const ie = newDateFmt(end, fmt)
    // date retrait - date episode
    de = moment(ie).diff(moment(d), 'days')
  }

  if (ds != null) {
    // Le catheter a été posé après l'infection
    if (ds < 0) {
      return 'N'
    }

    // Le catheter a été posé dans les 48h précédentes donc utilisé
    if (ds <= 2) {
      return 'Y'
    }

    // Le catheter n'a pas été retiré pendant la période
    if (rem != null && rem !== 1) {
      return 'Y'
    }

    // La date de fin est inconnue, on ne peut rien dire
    if (de == null) {
      return unk
    }

    // Le catheter a été retiré 2 jours avant l'infection ou après
    if (de >= -2) {
      return 'Y'
    }

    // Le catheter a été retiré plus de deux jours avant l'infection
    return 'N'
  }

  if (de != null) {
    // Le catheter a été retiré plus de 2 jours avant l'infection
    if (de < -2) {
      return 'N'
    }

    // Le catheter a été retiré dans les 2 jours avant l'infection
    if (de <= 0) {
      return 'Y'
    }
  }

  // Pas assez d'informations
  return unk
}

const infRecIds = []

function icuPtInfReducer (result, p) {
  const s = findSurveillance(result, p)
  const ds = findDataset(result, p)

  if (shouldBeIgnored(result, p, s, ds)) {
    return result
  }

  const sid = srvcId(p, s)
  const pid = patId(p, sid)

  const tags = []
  for (let i = 0; i !== p.f.catheters.length; ++i) {
    const b = p.f.catheters[i]

    if (b.isColIlcBlc < 2 || b.isColIlcBlc > 4) {
      continue
    }

    const invDev = getInvasiveDevice(
      b.episod, b.insertion, b.removal, b.removed
    )
    const d = newDateFmt(b.colIlcBlc, fmt)
    const ri = infId(pid, 'KT', d, i)

    const ktinfection = initializeHAIICUPtKt(
      b, pid, ri, getInfectionOutcome(p.f.dead), invDev, d
    )
    const k = `${ktinfection.BSIOrigin}/${ktinfection.InvasiveDevice}/${ktinfection.DateOfOnset}/${ktinfection.InfectionOutcome}/${ktinfection.InfectionSite}/${ktinfection.InfectionSiteOther}/${ktinfection.Res}`
    const t = tags.indexOf(k)
    if (t === -1) {
      tags.push(k)
      result.r.push(ktinfection)
      infRecIds.push(ktinfection.RecordId)
    }
  }

  for (let i = 0; i !== p.f.bacteremias.length; ++i) {
    const b = p.f.bacteremias[i]

    if (b.origin !== 1 && b.origin !== 2) {
      continue
    }
    const d = newDateFmt(b.episod, fmt)
    const ri = infId(pid, 'BACT', d, i)

    const infection = initializeHAIICUPtBact(
      b, pid, ri, getInfectionOutcome(p.f.dead), p.f.catheters, d
    )
    const k = `${infection.BSIOrigin}/${infection.InvasiveDevice}/${infection.DateOfOnset}/${infection.InfectionOutcome}/${infection.InfectionSite}/${infection.InfectionSiteOther}/${infection.Res}`
    const t = tags.indexOf(k)
    if (t === -1) {
      tags.push(k)
      result.r.push(infection)
      infRecIds.push(infection.RecordId)
    }
  }

  for (let i = 0; i !== p.f.pneumopathies.length; ++i) {
    const b = p.f.pneumopathies[i]

    const invDev = getInvasiveDevice(
      b.episod, p.f.intubStart, p.f.intubEnd
    )
    const d = newDateFmt(b.episod, fmt)
    const ri = infId(pid, 'PNE', d, i)

    const infection = initializeHAIICUPtPneu(
      b, pid, ri, getInfectionOutcome(p.f.dead), invDev, d
    )
    const k = `${infection.BSIOrigin}/${infection.InvasiveDevice}/${infection.DateOfOnset}/${infection.InfectionOutcome}/${infection.InfectionSite}/${infection.InfectionSiteOther}/${infection.Res}`
    const t = tags.indexOf(k)
    if (t === -1) {
      tags.push(k)
      result.r.push(infection)
      infRecIds.push(infection.RecordId)
    }
  }

  return result
}

function isKTCVC (t) {
  if (t === 'C1' || t === 'C4' || t === 'D1') {
    return true
  }
  return false
}

function icuPtExpReducer (result, p) {
  const s = findSurveillance(result, p)
  const ds = findDataset(result, p)

  if (shouldBeIgnored(result, p, s, ds)) {
    return result
  }
  const sid = srvcId(p, s)
  const pid = patId(p, sid)

  if (p.f.urinary === 1) {
    const uriEnd = getDateFallback([p.f.urinaryEnd, p.f.exit, p.f.death])

    const us = newDateFmt(p.f.urinaryStart, fmt)
    const uriStart = us != null ? us : unk

    const exposure = initializeHAIICUPtExp(
      uriStart,
      uriEnd,
      'UC',
      pid
    )

    result.r.push(exposure)
  }

  if (p.f.intubated === 1) {
    const itbEnd = getDateFallback([p.f.intubEnd, p.f.exit, p.f.death])
    const is = newDateFmt(p.f.intubStart, fmt)
    const itbStart = is != null ? is : unk
    const exposure = initializeHAIICUPtExp(
      itbStart,
      itbEnd,
      'INT',
      pid
    )
    result.r.push(exposure)
  }

  const tags = []
  for (let i = 0; i !== p.f.catheters.length; ++i) {
    const b = p.f.catheters[i]
    if (!isKTCVC(b.type_v2)) {
      continue
    }

    const ktEnd = getDateFallback([b.removal, p.f.exit, p.f.death])
    const ks = newDateFmt(b.insertion, fmt)
    const ktStart = ks != null ? ks : unk
    const exposure = initializeHAIICUPtExp(
      ktStart, ktEnd, 'CVC', pid, i
    )
    const k = `${exposure.ParentId}/${exposure.DateExpEnd}/${exposure.DateExpStart}/${exposure.ExpType}`
    const t = tags.indexOf(k)
    if (t === -1) {
      tags.push(k)
      result.r.push(exposure)
    }
  }

  return result
}

function addResistance (result, mos, iid) {
  const tags = []
  for (let i = 0; i !== mos.length; ++i) {
    const mo = mos[i]
    if (mo.antibio.length === 0) {
      const r = initializeHAIICUPtInfRes(null, mo, iid)
      if (r != null) {
        const k = `${r.RecordId}`
        const t = tags.indexOf(k)
        if (t === -1) {
          tags.push(k)
          result.r.push(r)
        }
      }
      continue
    }

    let pdr = unk
    for (let i = 0; i !== mo.antibio.length; ++i) {
      const res = mo.antibio[i]
      if (res.code === 5) {
        pdr = getResistance(res.code, res.resistance)
        break
      }
    }

    let done = [ 5 ]
    for (let i = 0; i !== mo.antibio.length; ++i) {
      const res = mo.antibio[i]
      if (done.findIndex(v => v === res.code) !== -1) {
        continue
      }

      done.push(res.code)

      const r = initializeHAIICUPtInfRes(res, mo, iid, pdr)
      if (r != null) {
        const k = `${r.RecordId}`
        const t = tags.indexOf(k)
        if (t === -1) {
          tags.push(k)
          result.r.push(r)
        }
      }
    }
  }
}

function hasParent (pid) {
  for (let i = 0; i !== infRecIds.length; ++i) {
    if (pid === infRecIds[i]) {
      return true
    }
  }
  return false
}

function addResistances (result, list, ignore, datefield, prefix, pid) {
  for (let i = 0; i !== list.length; ++i) {
    const b = list[i]
    if (ignore(b)) {
      continue
    }

    const d = newDateFmt(b[datefield], fmt)
    const iid = infId(pid, prefix, d, i)
    if (hasParent(iid)) {
      addResistance(result, b.microOrganisms, iid)
    }
  }
}

function shouldBeIgnored (result, p, s, ds) {
  if (result.p.OnlyClosed && !(s.status === 'closed' || ds.step === 2)) {
    return true
  }

  return false
}

function icuPtInfResReducer (result, p) {
  const s = findSurveillance(result, p)
  const ds = findDataset(result, p)

  if (shouldBeIgnored(result, p, s, ds)) {
    return result
  }

  const sid = srvcId(p, s)
  const pid = patId(p, sid)

  addResistances(
    result, p.f.catheters, (b) => b.isColIlcBlc < 2 || b.isColIlcBlc > 4,
    'colIlcBlc', 'KT', pid
  )

  addResistances(
    result, p.f.bacteremias, (b) => b.origin < 1 || b.origin > 2,
    'episod', 'BACT', pid
  )

  addResistances(
    result, p.f.pneumopathies, (b) => false,
    'episod', 'PNE', pid
  )

  return result
}

export function flatten (params) {
  const icu = convertEcdc(params, icuReducer)
  const icuPt = convertEcdc(params, icuPtReducer)
  const icuPtInf = convertEcdc(params, icuPtInfReducer)
  const icuPtExp = convertEcdc(params, icuPtExpReducer)
  const icuPtInfRes = convertEcdc(params, icuPtInfResReducer)

  const result = {
    icu: icu,
    icuPt: icuPt,
    icuPtInf: icuPtInf,
    icuPtExp: icuPtExp,
    icuPtInfRes: icuPtInfRes
  }
  return result
}

export function includeInRetrospectiveSurv (ds, un, uf, exd, dth, isDead) {
  const survEnd = new Date(getSurvEnd(ds, un, uf))
  const exitDate = isDead === 1 ? new Date(dth) : new Date(exd)

  return exitDate.setDate(exitDate.getDate() + 1) <= survEnd
}

export function bsiOriginKT (s, i, f) {
  if (i !== 4 || f !== 'BSI') {
    return ''
  }

  if (isCVCFromKt(s)) {
    return 'C-CVC'
  }

  if (s === 'C5') {
    return 'C-ART'
  }

  if (s === 'C6' || s === 'C7') {
    return 'C'
  }

  return 'UO'
}
